import React, { useEffect, useState } from 'react';
import {
  Alert,
  Typography,
  notification,
  Form,
  Select,
  Input,
  Descriptions,
  Skeleton,
  Card,
  Modal,
} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import CustomButton from '../../../components/CustomButton';
import MESSAGES from '../../../enums/Messages';
import {
  getGroupsAssign,
  getUsersAssign,
  sendObservations,
} from '../../../api/module/request_mod_assign';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import { useHistory } from 'react-router-dom';

const { Title } = Typography;

const ErrorsContent = ({ errors }) => {
  if (!errors) return null;
  console.log(errors, errors.j_y);
  return (
    <ul>
      {errors.a ? (
        <li>
          Ha seleccionado el módulo de Plazo mas no ha indicado la nueva fecha
          final
        </li>
      ) : null}
      {errors.bx ? <li>Debe tener al menos una responsabilidad</li> : null}
      {errors.cx ? (
        <li>
          Tiene productos fijos y/o con tope que no están asociados a un pago
        </li>
      ) : null}
      {errors.cy ? <li>Debe tener al menos un producto</li> : null}
      {errors.cz ? (
        <li>
          Hay productos que requieren eliminación y están asociados a un pago
        </li>
      ) : null}
      {errors.d ? (
        <li>
          Ha seleccionado el módulo de Ajuste presupuestal mas no ha indicado el
          valor del ajuste
        </li>
      ) : null}
      {errors.e > 0 ? (
        <li>
          La sumatoria del total de los pagos es menor que el valor total del
          contrato
        </li>
      ) : null}
      {errors.e < 0 ? (
        <li>
          La sumatoria del total de los pagos es mayor que el valor total del
          contrato
        </li>
      ) : null}
      {errors.e_j ? (
        <li>
          Ha seleccionado el módulo de Cambio de forma de pago mas no ha
          indicado la justificación
        </li>
      ) : null}
      {errors.h_x ? <li>Debe especificar si se requiere póliza.</li> : null}
      {errors.h_y ? (
        <li>
          Esta modificación contractual requiere póliza. Si no la solicita debe
          indicar la justificación.
        </li>
      ) : null}

      {errors.j_x ? <li>Debe especificar la fecha de suscripción.</li> : null}
      {errors.j_y ? (
        <li>La fecha de suscripción esta fuera del rango permitido</li>
      ) : null}
      {errors.text_errors.map((err) => (
        <li>{err.error}</li>
      ))}
    </ul>
  );
};

const AssignmentStates = ({ modificationId }) => {
  const navigate = useHistory();

  const [isLoading, setLoading] = useState(true);
  const [groups, setGroups] = useState(null);
  const [users, setUsers] = useState(null);
  const [observations, setObservations] = useState([]);
  const [statusProcess, setStatusProcess] = useState([]);
  const [errors, setErrors] = useState(undefined);
  const [formObservations] = Form.useForm();
  const [LoadSendForm, setLoadSendForm] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        if (modificationId) {
          const response = await getGroupsAssign(modificationId);
          setGroups(response.data.groups);
          setStatusProcess(response.data.statuses);
          setObservations(response.data.observations);
          setLoading(false);
        }
      } catch (err) {
        errorNotification();
      }
    }

    fetchData();
  }, [modificationId]);

  const errorNotification = () => {
    notification.error({
      message: MESSAGES.ERROR_MSG,
      description: MESSAGES.DESC_ERROR_GET_MSG,
      duration: 2,
    });
  };

  const getUsersData = async (id) => {
    setLoadingUsers(true);
    formObservations.setFieldsValue({
      usuario_destino: undefined,
    });
    setUsers(null);
    try {
      const response = await getUsersAssign(modificationId, id);
      setUsers(response.data.results);
    } catch (error) {
      errorNotification();
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleErrors = async (errors, data = undefined) => {
    setErrors({ errors, data });
    setErrorModal(true);
  };

  const sendObservation = async (data) => {
    setLoadSendForm(true);

    try {
      const response = await sendObservations(modificationId, data);
      if (response.data?.errors) {
        handleErrors(response.data.errors, data);
        setLoadSendForm(false);
        return;
      }
      formObservations.resetFields();
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        placement: 'bottomRight',
      });
      setTimeout(() => {
        navigate.push(`${INTERNAL_LINKS.CONTRACT_MODIFICATIONS}`);
      }, 1000);
    } catch (err) {
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        placement: 'bottomRight',
      });
    }
    setLoadSendForm(false);
  };

  return (
    <>
      <Modal
        title="Validación de modificación"
        open={errorModal}
        onOk={() => {
          sendObservation({ ...errors?.data, ignore_errors: true });
          setErrorModal(false);
        }}
        onCancel={() => setErrorModal(false)}
      >
        <>
          La modificación requiere ajustes:
          <ErrorsContent errors={errors?.errors} />
          ¿Desea enviarla de todos modos?
        </>
      </Modal>
      <Skeleton loading={isLoading} active>
        {errors?.errors.length > 0 && (
          <Alert
            message="Errores de validación:"
            type="warning"
            description={<ErrorsContent errors={errors} />}
          />
        )}
        <Card
          size={'small'}
          bordered={false}
          title={<Title level={3}>ASIGNACIÓN DE ESTADOS</Title>}
        >
          <Form
            form={formObservations}
            layout="vertical"
            onFinish={(data) => {
              sendObservation(data);
            }}
          >
            <Form.Item
              label="Selección el rol que revisará"
              name="rol"
              rules={[{ required: true }]}
            >
              <Select
                onChange={(value) => {
                  getUsersData(value);
                }}
                options={groups}
              />
            </Form.Item>

            <Form.Item
              label="Selección la persona que revisará"
              name="usuario_destino"
              rules={[{ required: true }]}
            >
              <Select
                loading={loadingUsers}
                disabled={loadingUsers}
                options={users}
              />
            </Form.Item>
            <Form.Item
              label="Estado para"
              name="estado_proceso"
              rules={[{ required: true }]}
            >
              <Select options={statusProcess} />
            </Form.Item>
            <Form.Item label="Observaciones" name="observacion">
              <Input.TextArea />
            </Form.Item>
            <Form.Item>
              <CustomButton
                loading={LoadSendForm}
                htmlType="submit"
                text="Enviar"
              />
            </Form.Item>
          </Form>
        </Card>

        {observations.length > 0 && (
          <Card
            size={'small'}
            bordered={false}
            title={<Title level={4}>Histórico de estados asignados</Title>}
            loading={isLoading}
          >
            {observations.map((item, index) => (
              <Descriptions
                title={`Estado No. ${index + 1}`}
                layout="vertical"
                column={4}
                bordered
                key={index}
              >
                <Descriptions.Item label="Usuario que realiza el envío y observación">
                  {item.nombre_completo}
                </Descriptions.Item>
                <Descriptions.Item label="Estado Asignado">
                  {item.estado_proceso_nombre}
                </Descriptions.Item>
                <Descriptions.Item label="Enviado a">
                  {item.rol_nombre}
                </Descriptions.Item>
                <Descriptions.Item label="Fecha y hora del envío">
                  {dayjs(item.created_at).format('DD MMMM YYYY HH:mm')}
                </Descriptions.Item>
                <Descriptions.Item label="Observación" span={4}>
                  {item.observacion}{' '}
                </Descriptions.Item>
              </Descriptions>
            ))}
          </Card>
        )}
      </Skeleton>
    </>
  );
};

export default AssignmentStates;

export { ErrorsContent };
